module.exports = __webpack_public_path__ + "media/images/lig/design-tiles/lig-tile-38-bd9fd1a7dcec0daf37b4c32b24a03537.jpg";